import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"

const LockIcon: FC = (): ReactElement => (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.77514 6.28386V3.56705C9.77514 1.65634 8.08568 0.107422 6.00065 0.107422C3.91604 0.107422 2.22616 1.65785 2.22616 3.56705V6.28386H1.46043C0.746286 6.28386 0.167348 6.89948 0.167348 7.65533V14.5202C0.167348 15.2777 0.745902 15.8917 1.46043 15.8917H10.5409C11.255 15.8917 11.834 15.2761 11.834 14.5202V7.65533C11.834 6.89786 11.2554 6.28386 10.5409 6.28386H9.77514ZM10.1673 7.99952V14.2495H1.83398V7.99952H10.1673ZM3.91732 6.28386V3.56705C3.91732 2.44323 4.64934 1.74952 6.00065 1.74952C7.35288 1.74952 8.08398 2.44219 8.08398 3.56705V6.28386H3.91732ZM6.68692 10.2535C6.68692 9.87458 6.38234 9.56737 6.00065 9.56737C5.62165 9.56737 5.31438 9.87191 5.31438 10.2535V12.3126C5.31438 12.6916 5.61896 12.9988 6.00065 12.9988C6.37965 12.9988 6.68692 12.6942 6.68692 12.3126V10.2535Z"
            fill={THEME.COLORS.blue[300]}
        />
    </svg>
)

export default { LockIcon }
